export const calculateColorStops = (numColors: number): string[] => {
	if (numColors <= 0) {
		return [];
	}

	const step: number = 100 / numColors;
	const stops: string[] = [];

	for (let i: number = 1; i <= numColors; i++) {
		const start: number = (i - 1) * step;
		const end: number = i * step;
		stops.push(`${start}% ${end}%`);
	}

	return stops;
};
